import { Col, Row } from "antd";
import { Control, FieldErrors } from "react-hook-form";
import { SelectField } from "../../../../../atoms/FormFields";
import { TimePickerField } from "../../../../../atoms/FormFields/TimePickerField";

const CrewYard = ({
  control,
  errors,
}: {
  control: Control;
  errors: FieldErrors;
}) => {
  return (
    <Row gutter={16}>
      <Col span={16}>
        <SelectField
          fieldName="crewYardName"
          label="Crew yard name"
          control={control}
          selectOption={[
            { label: "Main branch crew yard", value: "main_branch" },
            { label: "Second branch crew yard", value: "second_branch" },
            { label: "South-east yard", value: "south_east" },
          ]}
          iProps={{
            placeholder: "Select Crew yard name",
          }}
          isRequired
          rules={{
            required: "Crew yard name is required.",
          }}
          validate={errors.crewYardName && "error"}
          validMessage={
            typeof errors.crewYardName?.message === "string"
              ? errors.crewYardName.message
              : undefined
          }
          tooltipTitle="Crew yard name"
        />
      </Col>
      <Col span={8}>
        <TimePickerField
          fieldName="allocatedTime"
          label="Allocated time"
          control={control}
          isRequired
          rules={{
            required: "Allocated time is required.",
          }}
          validate={errors.allocatedTime && "error"}
          validMessage={
            typeof errors.allocatedTime?.message === "string"
              ? errors.allocatedTime.message
              : undefined
          }
          tooltipTitle="Allocated Time"
        />
      </Col>
    </Row>
  );
};

export default CrewYard;
